
import React from 'react';
import { FormFieldType } from '@/types/form';
import { fieldComponents } from '../fields';

interface StandardFormSectionProps {
  elements: FormFieldType[];
  documentUrls?: string[];
}

const StandardFormSection: React.FC<StandardFormSectionProps> = ({ elements, documentUrls = [] }) => {
  return (
    <div className="space-y-6">
      {elements.map((element) => {
        const FieldComponent = fieldComponents[element.type];
        
        if (!FieldComponent) {
          console.warn(`Field component type "${element.type}" not found for element:`, element);
          return null;
        }

        // Special handling for document_link field type
        if (element.type === 'document_link') {
          return (
            <div key={element.id} className="mb-4">
              <FieldComponent element={element} documentUrls={documentUrls} />
            </div>
          );
        }
        
        return (
          <div key={element.id} className="mb-4">
            <FieldComponent element={element} />
          </div>
        );
      })}
    </div>
  );
};

export default StandardFormSection;
